<template>
  <modal-template
    ref="modal"
    modal-size="lg"
    :title="title"
    type-modal="edit_editor_text_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">
        <d-form-row v-if="alert">
          <!-- Message -->
          <d-col md="12" class="alert alert-warning">
            <p class="mb-0">{{ alert }}</p>
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Obrigação -->
          <d-col md="12" class="form-group">
            <label>{{ label }}</label>
            <editor :ref="label" :id="label" :model.sync="model.name" />
          </d-col>
        </d-form-row>
      </d-form>
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-2"
        >Cancelar</d-button
      >
      <d-button type="button" @click="save()" class="btn btn-sm btn-info mr-2"
        >Salvar</d-button
      >
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Editor from '_shared/Editor.vue';
import ModalTemplate from '_shared/Modal.vue';
import {
  _OPEN_EDITOR_TEXT_MODAL_,
  MODEL_EDITOR_TEXT,
  _SAVE_EDITOR_TEXT_MODAL_,
} from '_modules/quotation/components/QuotationModel';

export default {
  name: 'edit-obligation-modal',
  props: {
    alert: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      model: { ...MODEL_EDITOR_TEXT },
      params: null,
      loading: false,
    };
  },
  computed: {
    label() {
      return this.params?.type === 'itemsIncluded'
        ? 'Item Incluso'
        : 'Obrigação';
    },
    title() {
      return this.params?.type === 'itemsIncluded'
        ? 'Alterar ou duplicar item incluso'
        : 'Alterar ou duplicar a obrigação';
    },
  },
  components: {
    Editor,
    ModalTemplate,
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert', 'getSettings']),
    close() {
      this.setToggle({ type: 'edit_editor_text_modal', bool: false });
    },
    save() {
      Events.$emit(_SAVE_EDITOR_TEXT_MODAL_, {
        item: this.model,
        params: this.params,
      });
      this.close();
    },
  },
  mounted() {
    Events.$on(_OPEN_EDITOR_TEXT_MODAL_, params => {
      this.model = params.item;
      this.params = params;
    });
  },
  destroyed() {
    Events.$off(_OPEN_EDITOR_TEXT_MODAL_);
  },
};
</script>
<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
